import { useWallet } from '@/providers/wallet-provider'
import { SignInDialog } from '@/components/signin-dialog'
import { Loader2, LogOut, Wallet } from 'lucide-react'

export function ConnectButton() {
  const {
    account,
    connected,
    connecting,
    signInPayload,
    startSignIn,
    handleSignInSuccess,
    cancelSignIn,
    disconnect,
  } = useWallet()

  return (
    <>
      {connected && account ? (
        <div className="flex flex-col items-center gap-3">
          <div className="flex items-center gap-3 px-5 py-3 rounded-xl bg-gray-900/80 border border-gray-700 backdrop-blur-sm">
            <span className="relative flex h-3 w-3">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-400 opacity-75" />
              <span className="relative inline-flex h-3 w-3 rounded-full bg-green-500" />
            </span>
            <span className="font-mono text-xrpl-blue text-sm tracking-wide">
              {account.address.slice(0, 8)}&hellip;{account.address.slice(-6)}
            </span>
          </div>

          <button
            type="button"
            onClick={disconnect}
            className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium text-gray-400 hover:text-red-400 hover:bg-red-950/30 border border-transparent hover:border-red-900/50 transition-all duration-200"
          >
            <LogOut className="h-4 w-4" />
            Disconnect
          </button>
        </div>
      ) : (
        <button
          type="button"
          onClick={startSignIn}
          disabled={connecting}
          className="inline-flex items-center gap-3 px-8 py-4 rounded-xl bg-gradient-to-r from-xrpl-blue to-xrpl-purple font-semibold text-white shadow-lg shadow-xrpl-blue/20 transition-all duration-200 hover:shadow-xrpl-blue/30 hover:scale-[1.02] active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
          aria-label={connecting ? 'Opening sign-in dialog' : 'Connect Xaman wallet'}
        >
          {connecting && !signInPayload ? (
            <>
              <Loader2 className="h-5 w-5 animate-spin" />
              Loading&hellip;
            </>
          ) : (
            <>
              <Wallet className="h-5 w-5" />
              Connect with Xaman
            </>
          )}
        </button>
      )}

      {signInPayload && (
        <SignInDialog
          payload={signInPayload}
          onSuccess={handleSignInSuccess}
          onClose={cancelSignIn}
        />
      )}
    </>
  )
}
